import { WalletStore } from '../states/wallet/wallet.store.js';
import { DepositsStore } from './../states/deposits/deposits.store.js';
import { DepositsApi } from '../apis/deposits.api.js';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { WalletQuery } from '../states/wallet/index.js';
import { CurrentUserFacade } from '@awread/core/users';

@Injectable({ providedIn: 'root' })
export class DepositsGear {
  currentUserFacade = inject(CurrentUserFacade);

  depositsApi = inject(DepositsApi);
  depositsStore = inject(DepositsStore);
  walletStore = inject(WalletStore);
  walletQuery = inject(WalletQuery);

  getAllDeposits() {
    return this.depositsApi.getAllDeposits().pipe(tap((res: any) => this.depositsStore.set(res)));
  }

  getAllDepositsByUserId() {
    return this.depositsApi.getAllDepositsByUserId().pipe(tap((res: any) => this.depositsStore.set(res)));
  }

  getDepositPendingByUserId() {
    return this.depositsApi.getDepositPendingByUserId();
  }

  getUserWallet(userId = this.currentUserFacade.getUserId()) {
    return this.depositsApi.getUserWallet(userId).pipe(tap((res: any) => this.walletStore.update(res)));
  }

  updateAkitaWallet(rewardAmount: string) {
    const currentWallet = this.walletQuery.getValue();
    return this.walletStore.update({
      ...currentWallet,
      balance: +currentWallet.balance + +rewardAmount,
    });
  }

  sendNotiDepositMail() {
    return this.depositsApi.sendNotiDepositMail();
  }
}
